var map = {
	"./danger-logo.svg": 3129,
	"./door-left-logo.svg": 6220,
	"./ekool-logo.svg": 7228,
	"./eliis-logo.svg": 7638,
	"./google-logo.svg": 3697,
	"./letter-logo.svg": 4586,
	"./lock-locked-logo.svg": 8930,
	"./microsoft-logo.svg": 8894,
	"./passkey-logo.svg": 2582,
	"./phone-logo.svg": 6014,
	"./protected-logo.svg": 8544,
	"./sms-logo.svg": 1420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9760;